const baseURL = process.env.REACT_APP_BASE_URL;

/** Socket.IO is on the same Adonis HTTP server as the API (no /api/v1 path). */
export const socketUrl =
  process.env.REACT_APP_SOCKET_URL ||
  (baseURL ? baseURL.replace(/\/api\/v1\/?$/, "") : "") ||
  "http://localhost:3333";

export const vendorAppUrl =
  process.env.REACT_APP_VENDOR_APP_URL || "https://vendor.touramp.xyz";

export default baseURL;
